import ABI from './abi.json';
import { ChainId } from '../../constants';

export const Config = {
    [ChainId.metisMainnet]: {
        address: '0x420000000000000000000000000000000000000F',
        abi: ABI,
    },
    [ChainId.metisTestnet]: {
        address: '0x420000000000000000000000000000000000000F',
        abi: ABI,
    },
};
